import { render, staticRenderFns } from "./DictionaryList.vue?vue&type=template&id=4b9150b4&scoped=true&"
import script from "./DictionaryList.vue?vue&type=script&lang=js&"
export * from "./DictionaryList.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryList.vue?vue&type=style&index=0&id=4b9150b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9150b4",
  null
  
)

export default component.exports